<template>
  <div>
    <div
      class="form-input mb-3"
      :class="{ error: !valid.last_name && validate }"
    >
      <b-form-input v-model="new_user.last_name" placeholder="Прізвище" />
    </div>
    <div
      class="form-input mb-3"
      :class="{ error: !valid.first_name && validate }"
    >
      <b-form-input v-model="new_user.first_name" placeholder="Імʼя" />
    </div>
    <div
      class="form-input mb-3"
      :class="{ error: !valid.middle_name && validate }"
    >
      <b-form-input v-model="new_user.middle_name" placeholder="По-батькові" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validate: false,
      new_user: {
        first_name: "",
        middle_name: "",
        last_name: "",
      },
    };
  },
  computed: {
    valid() {
      let valid = {
        first_name: true,
        middle_name: true,
        last_name: true,
      };
      if (this.new_user.first_name.length < 2) {
        valid.first_name = false;
      }
      if (this.new_user.middle_name.length < 2) {
        valid.middle_name = false;
      }
      if (this.new_user.last_name.length < 2) {
        valid.last_name = false;
      }

      return valid;
    },
  },
  methods: {
    confirm() {
      this.validate = true;
      let valid = true;
      for (var key in this.valid) {
        if (this.valid[key] == false) {
          valid = false;
        }
      }
      this.$emit("validate", {
        valid: valid,
        data: this.new_user,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
